import { reservations } from './role'

export const queries = {
  reservations,
}
export default queries
